export interface CompanyData {
  companyName: string;
  street: string;
  streetNumber?: string;
  postalCode: string;
  city: string;
  phone?: string;
  taxId: string;
  regon?: string;
}
